
<template>
  <swiper
    class="clickable"
    :modules="modules"
    :slides-per-view="'auto'"
    :space-between="12"
    :loop="true"
    :breakpoints = breakpoints
    :navigation = "{ nextEl:'.cards__control__next', prevEl:'.cards__control__prev'}"
    @swiper="onSwiper"
    @slideChange="onSlideChange"
  >
    <swiper-slide v-for="(item, index) in list" :key="index">
      <a :href="item.link">
        <figure>
          <img :src="item.pic" :alt="item.ttl">
          <figcaption>詳細を見る<svg width="11" height="10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="m6.143 9 4-4-4-4M10.143 5H1" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path></svg></figcaption>
        </figure>
        <dl>
          <dt v-html="item.ttl"></dt>
          <dd v-html="item.text"></dd>
        </dl>
        <svg class="plus" xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960"><path d="M460-300h40v-160h160v-40H500v-160h-40v160H300v40h160v160Zm20.13 180q-74.67 0-140.41-28.34-65.73-28.34-114.36-76.92-48.63-48.58-76.99-114.26Q120-405.19 120-479.87q0-74.67 28.34-140.41 28.34-65.73 76.92-114.36 48.58-48.63 114.26-76.99Q405.19-840 479.87-840q74.67 0 140.41 28.34 65.73 28.34 114.36 76.92 48.63 48.58 76.99 114.26Q840-554.81 840-480.13q0 74.67-28.34 140.41-28.34 65.73-76.92 114.36-48.58 48.63-114.26 76.99Q554.81-120 480.13-120Z"/></svg>
      </a>
    </swiper-slide>
  </swiper>
</template>

<style lang="scss" scoped>
.swiper-slide{
  max-width: 30rem;
  a{
    display: block;
    background: module.$main;
    color: module.$gray;
    border-radius: .8rem;
    overflow: hidden;
    position: relative;
    &:hover{
      figure{
        &:before{
          opacity: .8;
        }
        img{
          transform: scale(1.1);
        }
        figcaption{
          top: 50%;
          opacity: 1;
        }
      }
    }
  }
  figure{
    position: relative;
    overflow: hidden;
    &:before{
      content: '';
      width: 100%;
      height: 100%;
      background: module.$black;
      position: absolute;
      opacity: 0;
      inset: 0;
      z-index: 2;
      transition: opacity 400ms module.$ease;
    }
    img{
      width: 100%;
      aspect-ratio: 16 / 10;
      object-fit: cover;
      transition: transform 400ms module.$ease;
    }
    figcaption{
      font-size: 1.08rem;
      background: module.$white;
      color: module.$normal;
      padding: .32rem 2.4rem .4rem;
      border-radius: 999rem;
      white-space: nowrap;
      position: absolute;
      top: 60%;
      left: 50%;
      opacity: 0;
      transform: translate(-50%, -50%);
      z-index: 3;
      transition: all 400ms module.$ease;
      transition-property: top, opacity;
      svg{
        position: absolute;
        top: 50%;
        right: 1rem;
        transform: translateY(-50%);
      }
    }
  }
  dl{
    padding: 1.2rem 1.6rem;
    dt{
      font-size: 1.16rem;
    }
    dd{
      font-size: .92rem;
    }
  }
  .plus{
    position: absolute;
    right: .8rem;
    bottom: .8rem;
    width: 2.4rem;
    fill: module.tone(module.$main, 1);
  }
}
</style>

<script>
import { Navigation, Pagination, Scrollbar, A11y } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/vue'
export default {
  props: {
    list: {
      type: Array,
      required: true
    },
  },
  components: {
    Swiper,
    SwiperSlide,
  },
  setup() {
      const breakpoints = {
      1024: {
        spaceBetween: 32,
      },
      640: {
        spaceBetween: 20,
      },
    }

    const onSwiper = (swiper) => {
    }
    const onSlideChange = () => {
    }
    return {
      onSwiper,
      onSlideChange,
      breakpoints,
      modules: [Navigation, Pagination, Scrollbar, A11y],
    }
  },
}
</script>
